import { createForumAuthBaseQuery, initSharedForum } from '@bpreven/shared';
import { getCookie } from '../../utils/token';
import { baseQueryWithReauth } from '../api/base-query';

export const { forumApi, forumReducer } = initSharedForum({
  baseQuery: createForumAuthBaseQuery({
    baseQueryWithReauth,
    getAccessToken: (getState: () => unknown) => {
      const state = getState() as {
        user?: { accessToken?: string; activeContactToken?: string | null };
      };
      const token =
        getCookie('accessToken') ||
        getCookie('activeContactToken') ||
        state.user?.accessToken ||
        state.user?.activeContactToken;
      return token && token.length > 0 ? token : undefined;
    },
  }),
});
